import React, { useEffect } from 'react';

interface SenjaEmbedProps {
  senjaId: string;
}

const SCRIPT_URL = 'https://static.senja.io/dist/platform.js';

const SenjaEmbed = ({ senjaId }: SenjaEmbedProps): JSX.Element => {
  useEffect(() => {
    let script = document.querySelector(`script[src="${SCRIPT_URL}"]`) as HTMLScriptElement;

    if (script) return;

    script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.type = 'text/javascript';

    document.body.append(script);
  }, []);

  return (
    <div
      className='senja-embed'
      data-id={senjaId}
      data-mode='shadow'
      data-lazyload={false}
    />
  );
};

export default SenjaEmbed;
